import React from 'react'
import './Details.css'
import Slider from './Slider';

function Details() {
  return (
    <div className='Details' id='Details'>
      <div className='details1'>


        <div className='details-text'>
          <h2> تفاصيل المشروع </h2>
          <p>
            مكونات مشروع "الدار الكبيرة" تتوزع على ثلاثة طوابق بطريقة منظمة وعصرية. في الطابق الأرضي، يحتوي المشروع على محلين تجاريين، قاعة متعددة الاختصاصات، قاعة للأنشطة، مطبخ، محل للعاملين، مرافق صحية، مخزن، بهو واسع، محل خاص بالتمريض، مكتبين إداريين، بالإضافة إلى محل للحراسة. أما الطابق الأول، فيضم شقق سكنية متكاملة مخصصة للأطفال الأيتام، كل واحدة منها تحتوي على صالون، غرفة نوم، مطبخ صغير، حمام مع مرافق صحية، إضافة إلى محل للحراسة وساحة مخصصة للألعاب. في الطابقين الثاني والثالث، توجد 16 شقة سكنية أخرى مخصصة للإيواء. يعكس هذا المشروع التصميم الراقي والتوزيع الفعّال للمساحات بهدف توفير بيئة آمنة ومريحة للأطفال الأيتام، تضمن لهم الراحة والرعاية التي يحتاجونها في حياتهم اليومية.
          </p>
        </div>


        <div className='details_section'>

          <div className='details_Slider'>
            <Slider />
          </div>

          <br />
          <br />

          <div className='under_slider_images'>

            <img className='' src='assets/donation/don_data.png' alt='dar_lkbira' />

          </div>

          <div className='under_slider_images_mobile'>

            <img className='' src='assets/donation/thre_elements.png' alt='dar_lkbira' />

          </div>

        </div>



      </div>


      <img src='assets/donation/img4.png' alt='' className='mobile_50_awkaf' />


    </div>
  )
}
export default Details;
